export default {
  autoOpen: false,
  classes: {
    'ui-dialog': 'login-dialog',
    'ui-dialog-content': 'login-dialog__content',
    'ui-dialog-titlebar': 'login-dialog__title-bar',
    'ui-dialog-titlebar-close': 'login-dialog__close'
  },
  close: {},
  closeOnEscape: true,
  closeText: '',
  draggable: false,
  modal: true,
  padding: 0,
  resizable: false,
  width: 468
};



// WEBPACK FOOTER //
// src/app/components/login-dialog/login-dialog.settings.ts